import { ApiDocs } from '../../components/docs/ApiDocs';
import { mobileFetch, MOBILE_API_BASE } from '../api';

/**
 * Mobile's integration reference, rendered from the spec mobile itself serves.
 *
 * Everything on the page comes from that spec — see
 * {@link ../../components/docs/ApiDocs.ApiDocs} — so this file only has to say
 * which app's spec to read.
 */
export function MobileDocsPage() {
  return <ApiDocs apiBase={MOBILE_API_BASE} fetchSpec={mobileFetch} />;
}
